<template>
        <div class="filter-functions-sort-desktop col-xs-12">
            <div class="row">
                <div class="text-right col-xs-3 label-fixed-width">
                    <label>Results at a time:</label>
                </div>
                <div class="form-inline col-xs-9">
                    <span>
                        <select class="form-control" v-model="options.pageSize" @change="changed">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="10000">All</option>
                        </select>
                    </span>

                    <span>
                        <label>Sort by:</label>
                        <select class="form-control" v-model="options.sortDirection" @change="changed">
                            <option value="DESC">Recent first</option>
                            <option value="ASC">Oldest first</option>
                        </select>
                    </span>

                    <label>
                        <input type="checkbox" v-model="options.expandNotes" />
                        Expand all notes
                    </label>
                </div>
            </div>
        </div>
</template>

<script>
    import Vue from "vue";

    export default {
        data: function () {
            return {
                options: this.$store.state.searchFilter
            };
        },
        methods: {
            changed() {
                this.$emit('change');
            }
        }
    };
</script>

<style lang="scss">

</style>